import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { assistantRole, loadAssistant } from './assistant';

// Loaded once after sign-in: tells the assistant who is signed in (name, email
// and role, which decides how far it may work the screen) and which device is
// open (its name and status only, never its location). The map page's title
// names the open device, so the assistant knows where the user is; the other
// pages are titled by PageLayout.
const AssistantSetup = () => {
  const user = useSelector((state) => state.session.user);
  const device = useSelector((state) => state.devices.items[state.devices.selectedId]);
  const location = useLocation();

  useEffect(() => {
    loadAssistant().then((tyvane) => tyvane?.identify?.({
      name: user.name,
      email: user.email,
      role: assistantRole(user),
    }));
  }, [user.id, user.name, user.email, user.administrator, user.recovery]);

  useEffect(() => {
    loadAssistant().then((tyvane) => tyvane?.setContext?.(device ? {
      type: 'Device',
      name: device.name,
      status: device.status || '',
      lastUpdate: device.lastUpdate || '',
    } : null));
  }, [device?.id, device?.name, device?.status, device?.lastUpdate]);

  useEffect(() => {
    if (location.pathname === '/') {
      document.title = device ? `${device.name} · TowerGPS` : 'Map · TowerGPS';
    }
  }, [location.pathname, device?.name]);

  return null;
};

export default AssistantSetup;
